module.exports = __webpack_public_path__ + "static/media/icon-no-pic-white.9f6936d9.png";